import { LogOut, RotateCcw, Target } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { money } from "../../shared/domain";
import type { EarnSnapshot } from "../../shared/types";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth-context";

export function AccountPage() {
  const { session, logout } = useAuth();
  const [earn, setEarn] = useState<EarnSnapshot>();
  const navigate = useNavigate();
  useEffect(() => { void api.earn().then(setEarn); }, []);
  const signOut = async () => { await logout(); navigate("/"); };
  const reset = () => { if (window.confirm("Reset the entire local Bucks demo?")) { api.resetDemo(); navigate("/"); } };
  return (
    <div className="account-page page-width">
      <header className="page-title"><p className="eyebrow">JUST THE ESSENTIALS</p><h1>Account</h1></header>
      <section className="account-list">
        <div><span>Email</span><strong>{session?.user.email}</strong><small>{session?.user.emailVerified ? "Verified" : "Not verified"}</small></div>
        <div><span>Current goal</span><strong>{earn?.goal ? money(earn.goal.amountCents) : "—"}</strong><button type="button" onClick={() => navigate("/onboarding/goal")}><Target />Change goal</button></div>
        <div><span>Support</span><strong>Need help with an offer?</strong><button type="button" onClick={() => navigate("/support/missing-credit")}>Contact support</button></div>
      </section>
      <button className="button secondary account-action" onClick={signOut}><LogOut />Log out</button>
      {api.demo && <button className="text-danger" onClick={reset}><RotateCcw />Reset demo data</button>}
    </div>
  );
}
